// src/components/BookFinder/SearchBar.js

import React, { useState } from 'react';

// 1. Accept 'isSearching' in the props
const SearchBar = ({ onSearch, isSearching }) => {
  const [query, setQuery] = useState('');

  const handleInputChange = (event) => {
    setQuery(event.target.value);
  };

  const handleSearchClick = () => {
    onSearch(query);
  };

  return (
    <div className="search-bar">
      <input
        type="text"
        placeholder="Search for books by title..."
        value={query}
        onChange={handleInputChange}
      />
      {/* 2. Update the button */}
      <button onClick={handleSearchClick} disabled={isSearching}>
        {isSearching ? 'Searching...' : 'Search'}
      </button>
    </div>
  );
};

export default SearchBar;